var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector60(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 64,
    viewBox: "0 0 52 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2172 29.3665V62.0278M26.2172 29.3665L1.02271 15.8182M26.2172 29.3665L36.4253 23.7808M26.2172 62.0278L1.02271 48.7214V15.8182M26.2172 62.0278L50.9773 48.7214V15.8182M1.02271 15.8182L11.1889 10.2536M50.9773 15.8182L26.2172 2.02783L18.3982 6.30759M50.9773 15.8182L42.2895 20.572M36.4253 23.7808V35.4149L42.2895 32.2698V20.572M36.4253 23.7808L42.2895 20.572M36.4253 23.7808L11.1889 10.2536M42.2895 20.572L18.3982 6.30759M18.3982 6.30759L11.1889 10.2536M4.06342 38.802L11.8824 43.1569M3.62903 42.4311L9.49327 45.8182",
    stroke: "#006D77",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector60);
export default __webpack_public_path__ + "static/media/Vector 60.7d47d622b1da3d4e9c3475b68227876e.svg";
export { ForwardRef as ReactComponent };